<div [class.hidden]="_showPrintView" class="stats" [class.shown]="showStats">
  <app-mobility-widgets
    class="custom-scrollbar"
    [filter]="currentFilter"
    [stats]="mobilityStats"
    [compareMode]="compareMode"
    [compareLabels]="compareLabels"
    [legendColors]="generalLegendColors"
  >
    <app-campaign-widget
      [campaign]="currentCampaign"
      [comparedCampaign]="selectedCompareDelivery"
      [campaignPOIs]="campaignPOIs"
      [comparedCampaignPOIs]="comparedCampaignPOIs"
      [showOnlyCommonPOIs]="showOnlyCommonPOIs"
      (onToggleCommonPOIs)="onToggleCommonPOIs()"
      (onClickViewFullTable)="openRankingList()"
      (onDeleteCampaign)="toggleDeleteCampaignModal()"
    ></app-campaign-widget>

    <app-stats-widget
      infoTooltip="Total {{
        keyIndicatorLabel.toLowerCase()
      }} for the POIs in the selected campaign"
      [isMultiple]="compareMode"
      *ngIf="reachSumWidgetData.length"
      [stats]="reachSumWidgetData"
      [referenceLabel]="widgetReferenceLabel"
      [comparedLabel]="widgetComparedLabel"
    ></app-stats-widget>
    <app-stats-widget
      infoTooltip="Average reach for the POIs in the selected campaign"
      [isMultiple]="compareMode"
      *ngIf="reachAvgWidgetData.length"
      [stats]="reachAvgWidgetData"
      [referenceLabel]="widgetReferenceLabel"
      [comparedLabel]="widgetComparedLabel"
    ></app-stats-widget>
    <app-stats-widget
      infoTooltip="Average impressions for the POIs in the selected campaign"
      [isMultiple]="compareMode"
      *ngIf="impressionsWidgetData.length"
      [stats]="impressionsWidgetData"
      [referenceLabel]="widgetReferenceLabel"
      [comparedLabel]="widgetComparedLabel"
    ></app-stats-widget>
    <app-stats-widget
      infoTooltip="Vehicles impacted for the POIs in the selected campaign"
      [isMultiple]="compareMode"
      *ngIf="trafficWidgetData.length"
      [stats]="trafficWidgetData"
      [referenceLabel]="widgetReferenceLabel"
      [comparedLabel]="widgetComparedLabel"
    ></app-stats-widget>

    <!-- <app-comparison-audience-widget
      *ngIf="reachWidgetData.length"
      [title]="'Reach' | translate"
      [data]="reachWidgetData"
    ></app-comparison-audience-widget>
    <app-comparison-audience-widget
      *ngIf="trafficWidgetData.length"
      [title]="'Vehicles Impacted' | translate"
      [data]="trafficWidgetData"
    >
    </app-comparison-audience-widget> -->

    <app-comparison-ranking-list
      *ngIf="mobilityStats?.ranking"
      [title]="
        ('Ranking of assets by' | translate) +
        ' ' +
        (keyIndicatorLabel | translate)
      "
      [popupTitle]="'Campaign Assets' | translate"
      [data]="mobilityStats?.ranking?.data"
      [columns]="mobilityStats?.ranking?.columns"
      [labelKey]="mobilityStats?.ranking?.label"
      [valueKey]="mobilityStats?.ranking?.key"
      (onClickViewFullTable)="openRankingList()"
    ></app-comparison-ranking-list>
    <app-pie-chart-widget
      class="gender"
      *ngIf="mobilityStats?.gender"
      title="{{ 'Gender distribution' | translate }} (%)"
      [data]="mobilityStats?.gender"
      [labels]="genderCompareLabel"
      [isMultiple]="compareMode"
      [colors]="[colorMen, colorWomen]"
      [unit]="keyIndicatorLabel.toLowerCase() | translate"
      icon="/assets/img/icons/color/genders.svg"
      [stats]="mobilityStats?.targetStats?.visitors"
    >
    </app-pie-chart-widget>
    <app-pyramid-widget
      *ngIf="mobilityStats?.age"
      title="{{ 'Population distribution' | translate }} (%)"
      [data]="mobilityStats?.age"
      [isMultiple]="compareMode"
      [labels]="compareLabels"
      unit="%"
      description="{{ 'pct. by age groups, both genders' | translate }}"
    ></app-pyramid-widget>
    <app-bars-widget
      *ngIf="mobilityStats?.visitor_profile"
      title="{{ 'Reach by type' | translate }}"
      [data]="mobilityStats?.visitor_profile"
      [isMultiple]="compareMode"
      unit="%"
      formatNumber="1.0-1"
    ></app-bars-widget>
  </app-mobility-widgets>
</div>

<div [class.hidden]="_showPrintView" id="mapContainer">
  <div class="no-campaign-warning" *ngIf="!currentCampaign">
    <p>
      <img src="/assets/img/icons/color/warning-s.svg" alt="warning icon" />
      <span>{{
        'There are no campaigns currently available. Please go to the map section to create one'
          | translate
      }}</span>
    </p>
  </div>
  <app-map-hover-popup
    *ngIf="hoverPopupData.show"
    [style.top.px]="hoverPopupData.top"
    [style.left.px]="hoverPopupData.left"
    [data]="hoverPopupData.data"
    [tooltip]="hoverPopupData.tooltip"
    [tooltipExtra]="hoverPopupData.tooltipExtra"
    [primary]="hoverPopupData.primary"
    [showFrom]="hoverPopupData.showFrom"
  >
  </app-map-hover-popup>
  <div style="display: none">
    <app-map-click-popup #mapClickPopup></app-map-click-popup>
  </div>

  <app-map
    #map
    *ngIf="mapBbox.length"
    [mapBbox]="mapBbox"
    [center]="mapCenter"
    [zoom]="mapZoom"
    [styles]="currentBasemap?.value"
    [authorization]="getAuthorizationToken()"
    (mapLoaded)="onMapLoaded()"
    [attr.class]="currentBasemap?.id"
  >
  </app-map>

  <div id="topLeftContainer">
    <div class="columnWrapper">
      <app-map-controls
        *ngIf="mapLoaded"
        [map]="map"
        [basemapList]="basemapList"
        (basemapChanged)="changeBasemap($event)"
      ></app-map-controls>
      <app-footer></app-footer>
    </div>
    <app-map-loading
      *ngIf="isLoading"
      [attr.class]="currentBasemap?.id"
    ></app-map-loading>
    <app-summary
      *ngIf="!isLoading"
      [stats]="visitorsSum"
      [compareMode]="compareMode"
      [datasetName]="currentCampaign?.name"
      [selectedCompareDelivery]="selectedCompareDelivery"
      [showContext]="!isFilterPanelShown"
      class="{{ currentBasemap?.id }}"
    >
    </app-summary>
  </div>
  <app-map-attribute></app-map-attribute>
</div>

<app-campaign-filter-bar
  *ngIf="currentCampaign"
  [deliveries]="campaigns"
  [currentDelivery]="currentCampaign"
  [class.hidden]="_showPrintView"
  [showCompareDeliveries]="true"
  (shownToggle)="onFilterPanelToggle($event)"
  (deliveryToCompare)="deliveryToCompareSelected($event)"
  (onChangeDelivery)="deliveryChange($event)"
  (finishTogggleAnimation)="invalidateMapSize()"
></app-campaign-filter-bar>

<app-popup-ranking-campaigns
  *ngIf="showRankingPopup"
  [title]="'Campaign Assets' | translate"
  [data]="mobilityStats?.ranking?.data"
  [columns]="mobilityStats?.ranking?.columns"
  [labelKey]="mobilityStats?.ranking?.label"
  [valueKey]="mobilityStats?.ranking?.key"
  (onCloseClick)="showRankingPopup = false"
></app-popup-ranking-campaigns>

<app-modal
  [status]="deleteConfirmModalStatus"
  *ngIf="showDeleteConfirmModal"
  class="delete-confirm-modal"
  [showHeader]="false"
>
  <div class="header">
    <p class="title">
      {{ 'Are you sure you want to delete this campaign?' | translate }}
    </p>
    <button class="close-btn" (click)="showDeleteConfirmModal = false">
      <img alt="close icon" src="/assets/img/icons/positive-clear/close.svg" />
    </button>
  </div>
  <div class="actions">
    <button
      [class.disabled]="deleteCampaignLoading"
      [class.loading]="deleteCampaignLoading"
      [disabled]="deleteCampaignLoading"
      class="confirm-btn"
      (click)="deleteCampaign()"
    >
      <span class="label">{{ 'Confirm' | translate }}</span>
      <span *ngIf="deleteCampaignLoading" class="btn-spinner"></span>
    </button>
    <button
      [class.disabled]="deleteCampaignLoading"
      [disabled]="deleteCampaignLoading"
      class="cancel-btn"
      (click)="showDeleteConfirmModal = false"
    >
      {{ 'Cancel' | translate }}
    </button>
  </div>
</app-modal>

<div class="csv-download" [class.closed-panel]="!isFilterPanelShown">
  <button
    (click)="downloadCSV()"
    class="generic-tooltip"
    [attr.data-tooltip]="'Download Campaign CSV' | translate"
  >
    <img alt="download icon" src="/assets/img/icons/accent/download.svg" />
  </button>
</div>
